<template>
  <a-modal v-model="visible" :title="`${form.id ? $t('编辑字典内容信息') : $t('新增字典内容信息')}`" :width="1000" destroyOnClose>
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button :loading="loading" type="primary" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('所属字典')">
            <a-input v-model="form.dictName" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('标题')" prop="label">
            <a-input v-model="form.label" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('英文标题')" prop="labelEn">
            <a-input v-model="form.labelEn" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('值')" prop="dictValue">
            <a-input v-model="form.dictValue" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('备注')" prop="remark">
            <a-textarea v-model="form.remark" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { saveDictContent } from '@/api/system/dict'

export default {
  data() {
    return {
      visible: false,
      form: {},
      loading: false,
    }
  },
  computed: {
    rules() {
      const result = {
        label: [{ required: true, message: this.$t('请输入') }],
        dictValue: [{ required: true, message: this.$t('请输入') }],
      }
      return result
    }
  },
  created() {
  },
  methods: {
    show(data) {
      this.form = { ...data }
      this.visible = true
    },
    handleCommit() {
      this.$refs.form.validate((success) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          ...this.form,
        }
        saveDictContent(commitData).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('保存成功'))
            this.$emit('ok', this.form)
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).catch(err => {
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>